import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

// Bypass the Web Locks API (navigator.locks) which hangs in sandboxed iframes,
// incognito mode on some browsers, and certain privacy extensions.
// This custom lock immediately executes the callback instead of queuing it.
const noOpLock = <R>(_name: string, _timeout: number, fn: () => Promise<R>): Promise<R> => fn();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    lock: noOpLock,
  },
});

export type User = {
  id: string;
  email: string;
  full_name: string | null;
  avatar_url: string | null;
  skool_group_url: string | null;
  skool_group_name: string | null;
  plan_id: string | null;
  role: "user" | "admin";
  status: "active" | "suspended" | "cancelled";
  trial_ends_at: string | null;
  ai_credits_used: number;
  ai_credits_limit: number;
  referral_code: string | null;
  referred_by: string | null;
  created_at: string;
  updated_at: string;
};

export type Plan = {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  price_monthly: number;
  price_yearly: number;
  features: string[];
  networks_allowed: string[];
  ai_posts_monthly: number;
  social_accounts_limit: number;
  team_members_limit: number;
  is_active: boolean;
  sort_order: number;
};
